var GamepadInput = require("./gamepadInput.js");
const ControlBind = require("./controlBind.js");
const mobileControls = require("./mobileControls.js");
const UTILS = require("./utils.js");
const config = require("../config.js");
module.exports = function (RENDER, UI, game, io, overlay, isMobile) {
  function requestPointerLock() {
    if (controls.mouseAccel) {
      return v13842.requestPointerLock();
    }
    const v13826 = v13842.requestPointerLock({
      unadjustedMovement: false
    });
    if (v13826) {
      return v13826.catch(p17671 => {
        if (p17671.name === "NotSupportedError") {
          return v13842.requestPointerLock();
        }
      });
    } else {
      return v13842.requestPointerLock();
    }
  }
  function f2127(event) {
    var v13827 = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
    var v13828 = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
    if (!controls.mouseSkipFix || v13827 < controls.flickClamp && v13827 > -controls.flickClamp) {
      v13852 = v13827;
    }
    vLN02533 += v13852 || 0;
    if (!controls.mouseSkipFix || v13828 < controls.flickClamp && v13828 > -controls.flickClamp) {
      v13853 = v13828;
    }
    vLN02534 += v13853 || 0;
    controls.mouseX = event.clientX;
    controls.mouseY = event.clientY;
    RENDER.tmpMouse.set(event.clientX, event.clientY);
    RENDER.tmpMouse2.set(v13827, v13828);
  }
  function f2128(p17673, p17674) {
    return {
      identifier: p17673.identifier,
      pageX: p17673.pageX,
      pageY: p17673.pageY,
      screenX: p17673.screenX,
      screenY: p17673.screenY,
      cb: p17674
    };
  }
  function f2129(p17675) {
    for (var vLN02529 = 0; vLN02529 < vA782.length; vLN02529++) {
      if (vA782[vLN02529].identifier == p17675) {
        return vLN02529;
      }
    }
    return -1;
  }
  function f2130(p17676, p17677) {
    var v13829 = p17677.direction;
    var v13830 = p17677.distance || 50;
    var v13831 = Math.abs(p17677.angle.degree - 180);
    if (v13829) {
      if (controls.mblInput.gradSpeed) {
        controls.speedLmt = v13830 / 50;
      }
      if (v13831 >= 165 && v13831 <= 195 || v13831 >= 0 && v13831 <= 15) {
        f2135(null, controls.binds.move[0].val, "mblInput");
        f2135(null, controls.binds.move[1].val, "mblInput");
      } else {
        if (v13829.y == "up") {
          f2135(null, controls.binds.move[1].val, "mblInput");
          f2134(null, controls.binds.move[0].val, "mblInput");
        } else {
          f2135(null, controls.binds.move[0].val, "mblInput");
        }
        if (v13829.y == "down") {
          f2135(null, controls.binds.move[0].val, "mblInput");
          f2134(null, controls.binds.move[1].val, "mblInput");
        } else {
          f2135(null, controls.binds.move[1].val, "mblInput");
        }
      }
      if (v13831 >= 75 && v13831 <= 105) {
        f2135(null, controls.binds.move[2].val, "mblInput");
        f2135(null, controls.binds.move[3].val, "mblInput");
      } else {
        if (v13829.x == "left") {
          f2135(null, controls.binds.move[3].val, "mblInput");
          f2134(null, controls.binds.move[2].val, "mblInput");
        } else {
          f2135(null, controls.binds.move[2].val, "mblInput");
        }
        if (v13829.x == "right") {
          f2135(null, controls.binds.move[2].val, "mblInput");
          f2134(null, controls.binds.move[3].val, "mblInput");
        } else {
          f2135(null, controls.binds.move[3].val, "mblInput");
        }
      }
    }
  }
  function f2131(p17678) {
    f2135(null, controls.binds.move[0].val, "mblInput");
    f2135(null, controls.binds.move[1].val, "mblInput");
    f2135(null, controls.binds.move[2].val, "mblInput");
    f2135(null, controls.binds.move[3].val, "mblInput");
  }
  function f2132(p17679, p17680) {
    var v13832 = p17679.screenX - vA782[p17680].screenX;
    var v13833 = p17679.screenY - vA782[p17680].screenY;
    controls.fakeMouse(2, v13832, v13833, 0, "mblInput");
  }
  function f2133(p17681, p17682, p17683, p17684) {
    controls.idleTimer = 0;
    if (controls.keys) {
      if (!p17684 && p17682 && controls.keys[p17681] !== p17682 && controls.inputChanger != null) {
        controls.updateBind(controls.inputChanger[0], controls.inputChanger[1], controls.inputChanger[2], p17681);
        showWindow(7, true);
        updateKeybindUI(controls.inputChanger[0] + (UTILS.isNumber(controls.inputChanger[2]) ? controls.inputChanger[2] : ""));
        controls.inputChanger = null;
      } else {
        if (controls.keys[p17681] !== p17682 && (p17681 == "voiceChat" || controls.binds.voiceChat.isKey(p17681))) {
          toggleRecord(p17682);
        }
        if (!controls.enabled && p17681 != 27 && p17681 != "menu") {
          return;
        }
        if (controls.keys[p17681] !== p17682) {
          if (p17682 == 1 && !controls.didPressed[p17681]) {
            controls.didPressed[p17681] = 1;
          }
          controls.keys[p17681] = p17682;
          for (var vLN02530 = 0; vLN02530 < controls.binds.move.length; vLN02530++) {
            if (p17681 == "move_" + vLN02530 || controls.binds.move[vLN02530].isKey(p17681)) {
              controls.updateMoveDir();
              break;
            }
          }
          if (p17682) {
            if (p17681 == "swap" || controls.binds.swap.isKey(p17681)) {
              controls.wSwap = 1;
            } else if (p17681 == "melee" || controls.binds.melee.isKey(p17681)) {
              controls.wSwap = 2;
            } else if (controls.binds.primary.isKey(p17681)) {
              controls.wSwap = 3;
            } else if (controls.binds.equip.isKey(p17681)) {
              controls.wSwap = 4;
            }
            if (p17684) {
              window.pressButton(null, null, p17681);
            } else {
              window.pressButton(p17681, p17683);
            }
          } else if (p17684) {
            window.releaseButton(null, null, p17681);
          } else {
            window.releaseButton(p17681, p17683);
          }
        } else if (controls.keys[p17681] === p17682 && p17682 == 1 && !p17684 && p17683 && game && game.mainScript && game.mainScript.onKeyHeld) {
          game.mainScript.onKeyHeld((p17683.key + "").toLowerCase(), p17683.which || p17683.keyCode || 0);
        }
      }
    }
  }
  function f2134(p17685, p17686, p17687) {
    v13881 = p17686 || p17685.which || p17685.keyCode;
    if (p17687 != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    controls.inputType = p17687;
    if (p17685 && p17685.key == "/" && p17685.ctrlKey) {
      window.setLastMod("");
      windows[3].reset(true);
    } else if (v13881 == controls.binds.chat.val) {
      window.pressButton(v13881, p17685);
    } else if (document.activeElement != chatInput && (!window.tradeChatInput || document.activeElement != window.tradeChatInput)) {
      if (controls.enabled && p17685 && p17685.preventDefault && p17685.cancelable) {
        p17685.preventDefault();
      }
      f2133(v13881 || 0, 1, p17685, p17687 == "cntrlInput");
    }
  }
  function f2135(p17688, p17689, p17690) {
    v13881 = p17689 || p17688.which || p17688.keyCode;
    if (p17690 != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    controls.inputType = p17690;
    if (controls.enabled && p17688 && p17688.preventDefault && p17688.cancelable) {
      p17688.preventDefault();
    }
    f2133(v13881 || 0, 0, p17688, p17690 == "cntrlInput");
  }
  var controls = this;
  this.binds = {};
  this.binds.primary = new ControlBind("primKey", 84, -1);
  this.binds.reload = new ControlBind("reloadKey", 82, -1);
  this.binds.jump = new ControlBind("jumpKey", 32, -1);
  this.binds.playerList = new ControlBind("pListKey", 18, -1);
  this.binds.scoreBoard = new ControlBind("sBoardKey", 9, -1);
  this.binds.interact = new ControlBind("interactKey", 71, -1);
  this.binds.confirm = new ControlBind("confirmKey", 75, -1);
  this.binds.secondaryInteract = new ControlBind("interactSecKey", 72, -1);
  this.binds.reset = new ControlBind("resetKey", 66, -1);
  this.binds.resetLast = new ControlBind("resetLastKey", 78, -1);
  this.binds.spray = new ControlBind("sprayKey", 70, -1);
  this.binds.sprayWheel = new ControlBind("sprayWheelKey", 70, -1);
  this.binds.inspect = new ControlBind("inspKey", 88, -1);
  this.binds.swap = new ControlBind("swapKey", 69, -1);
  this.binds.shoot = new ControlBind("shoot1Key", 10001, 220);
  this.binds.aim = new ControlBind("aim1Key", 10003, 221);
  this.binds.crouch = new ControlBind("crouchKey", 16, -1);
  this.binds.melee = new ControlBind("meleeKey", 81, -1);
  this.binds.equip = new ControlBind("equipKey", 67, -1);
  this.binds.chat = new ControlBind("chatKey", 13, -1);
  this.binds.voiceChat = new ControlBind("voiceKey", 86, -1);
  this.binds.drop = new ControlBind("dropKey", 90, -1);
  this.binds.wepVis = new ControlBind("wepVisKey", -1, -1);
  this.binds.kickVoteY = new ControlBind("kickVoteYKey", 49, -1);
  this.binds.kickVoteN = new ControlBind("kickVoteNKey", 50, -1);
  this.binds.specFree = new ControlBind("specFreeKey", 70, -1);
  this.binds.specObj = new ControlBind("specObjKey", 72, -1);
  this.binds.specFirst = new ControlBind("specFirstKey", 82, -1);
  this.binds.specNames = new ControlBind("specNamesKey", 77, -1);
  this.binds.specMiniMap = new ControlBind("specMiniMap", 189, -1);
  this.binds.kpdVoteY = new ControlBind("kpdVoteYKey", 89, -1);
  this.binds.kpdVoteN = new ControlBind("kpdVoteNKey", 78, -1);
  this.binds.specFocus = new ControlBind("specFocusKey", 190, -1);
  this.binds.kpdVision = new ControlBind("kpdVisionKey", 187, -1);
  this.binds.hidePlayers = new ControlBind("hidePlayersKey", -1, -1);
  this.binds.prop = new ControlBind("propKey", 80, -1);
  this.binds.propRand = new ControlBind("propRandKey", 77, -1);
  this.binds.propRot = new ControlBind("propRotKey", 82, -1);
  this.binds.propRotR = new ControlBind("propRotRKey", 78, -1);
  this.binds.noclipSB = new ControlBind("sandboxNoclip", -1, -1);
  this.binds.godModeSB = new ControlBind("sandboxGodMode", -1, -1);
  this.binds.killSB = new ControlBind("sandboxKill", -1, -1);
  this.binds.spawnBot = new ControlBind("sandboxSpawnBot", 107, -1);
  this.binds.clearBots = new ControlBind("sandboxClearBots", 109, -1);
  this.binds.streak = [new ControlBind("18", 49, -1), new ControlBind("19", 50, -1), new ControlBind("20", 51, -1)];
  this.binds.taunt = [new ControlBind("taunt0", 49, -1), new ControlBind("taunt1", 50, -1), new ControlBind("taunt2", 51, -1), new ControlBind("taunt3", 52, -1), new ControlBind("taunt4", 53, -1), new ControlBind("taunt5", 54, -1)];
  this.binds.move = [new ControlBind("0", 87, -1), new ControlBind("1", 83, -1), new ControlBind("2", 65, -1), new ControlBind("3", 68, -1)];
  this.binds.toggle = [new ControlBind("27", -1, -1), new ControlBind("28", -1, -1), new ControlBind("29", -1, -1), new ControlBind("30", -1, -1), new ControlBind("31", -1, -1), new ControlBind("32", -1, -1)];
  this.binds.premium = [new ControlBind("34", -1, -1), new ControlBind("35", -1, -1), new ControlBind("36", -1, -1), new ControlBind("37", -1, -1)];
  this.binds.message = [new ControlBind("43", -1, -1), new ControlBind("44", -1, -1), new ControlBind("45", -1, -1), new ControlBind("46", -1, -1), new ControlBind("47", -1, -1), new ControlBind("48", -1, -1)];
  this.scrollToSwap = true;
  this.toggleSets = [getSavedVal("cont_27_set") || -1, getSavedVal("cont_28_set") || -1, getSavedVal("cont_29_set") || -1, getSavedVal("cont_30_set") || -1, getSavedVal("cont_31_set") || -1, getSavedVal("cont_32_set") || -1];
  this.chatMessages = [getSavedVal("cont_43_set") || "", getSavedVal("cont_44_set") || "", getSavedVal("cont_45_set") || "", getSavedVal("cont_46_set") || "", getSavedVal("cont_47_set") || "", getSavedVal("cont_48_set") || ""];
  this.checkScroll = function () {
    for (var v13834 in controls.binds) {
      if (Array.isArray(controls.binds[v13834])) {
        for (var vLN02531 = 0; vLN02531 < controls.binds[v13834].length; vLN02531++) {
          if (controls.binds[v13834][vLN02531].isKey(20000) || controls.binds[v13834][vLN02531].isKey(10002)) {
            controls.scrollToSwap = false;
            return;
          }
        }
      } else if (controls.binds[v13834].isKey(20000) || controls.binds[v13834].isKey(10002)) {
        controls.scrollToSwap = false;
        return;
      }
    }
    controls.scrollToSwap = true;
  };
  this.checkScroll();
  this.resetBinds = function () {
    for (var v13835 in controls.binds) {
      if (Array.isArray(controls.binds[v13835])) {
        controls.binds[v13835].forEach(p17691 => p17691.resetAll());
      } else {
        controls.binds[v13835].resetAll();
      }
    }
    controls.checkScroll();
    controls.toggleSets = [getSavedVal("cont_27_set") || -1, getSavedVal("cont_28_set") || -1, getSavedVal("cont_29_set") || -1, getSavedVal("cont_30_set") || -1, getSavedVal("cont_31_set") || -1, getSavedVal("cont_32_set") || -1];
    controls.chatMessages = [getSavedVal("cont_43_set") || "", getSavedVal("cont_44_set") || "", getSavedVal("cont_45_set") || "", getSavedVal("cont_46_set") || "", getSavedVal("cont_47_set") || "", getSavedVal("cont_48_set") || ""];
  };
  this.export = function () {
    var vO454 = {};
    for (var v13836 in controls.binds) {
      if (Array.isArray(controls.binds[v13836])) {
        var v13837 = v13836 + "Keys";
        vO454[v13837] = [];
        vO454[v13837 + "_alt"] = [];
        for (var vLN02532 = 0; vLN02532 < controls.binds[v13836].length; vLN02532++) {
          if (controls.binds[v13836][vLN02532].val != controls.binds[v13836][vLN02532].def) {
            vO454[v13837][vLN02532] = controls.binds[v13836][vLN02532].val;
          }
          if (controls.binds[v13836][vLN02532].altVal != controls.binds[v13836][vLN02532].altDef) {
            vO454[v13837 + "_alt"][vLN02532] = controls.binds[v13836][vLN02532].altVal;
          }
        }
        if (!vO454[v13837].length) {
          delete vO454[v13837];
        }
        if (!vO454[v13837 + "_alt"].length) {
          delete vO454[v13837 + "_alt"];
        }
      } else {
        if (controls.binds[v13836].val != controls.binds[v13836].def) {
          vO454[controls.binds[v13836].name] = controls.binds[v13836].val;
        }
        if (controls.binds[v13836].altVal != controls.binds[v13836].altDef) {
          vO454[controls.binds[v13836].altName] = controls.binds[v13836].altVal;
        }
      }
    }
    vO454.toggleSets = [...controls.toggleSets];
    if (!vO454.toggleSets.join("").length) {
      delete vO454.toggleSets;
    }
    vO454.chatMessages = [...controls.chatMessages];
    if (!vO454.chatMessages.join("").length) {
      delete vO454.chatMessages;
    }
    return vO454;
  };
  this.getBindByName = function (p17692, p17693) {
    for (var v13838 in controls.binds) {
      if (!Array.isArray(controls.binds[v13838]) && (controls.binds[v13838].name == p17692 || controls.binds[v13838].altName == p17692)) {
        return controls.binds[v13838];
      }
    }
    return false;
  };
  this.updateBind = function (p17694, p17695, p17696, p17697, p17698) {
    if (controls.binds[p17694] && (p17696 == null || controls.binds[p17694][p17696])) {
      if (p17696 == null) {
        controls.binds[p17694].update(p17697, p17695);
      } else {
        controls.binds[p17694][p17696].update(p17697, p17695);
      }
      if (!p17698) {
        controls.checkScroll();
      }
    }
  };
  this.resetBind = function (p17699, p17700, p17701, p17702) {
    if (controls.binds[p17699] && (p17701 == null || controls.binds[p17699][p17701])) {
      if (p17701 == null) {
        controls.binds[p17699].reset(p17700);
      } else {
        controls.binds[p17699][p17701].reset(p17700);
      }
      if (!p17702) {
        controls.checkScroll();
      }
    }
  };
  this.camRot = true;
  this.freeMouse = false;
  this.UsePointerLock = true;
  this.camOffset = false;
  this.spect = {
    target: null,
    speed: 1,
    followDis: config.specMinD,
    minD: config.specMinD,
    maxD: config.specMaxD
  };
  this.camType = {
    isNormal: true,
    isTop: false,
    isSideX: false,
    isSideZ: false
  };
  var vF103 = () => !!controls && !!controls.keys && !!controls.binds && !!controls.keys[controls.binds.aim.val];
  this.scaleMap = {};
  this.isMobile = isMobile;
  if (this.isMobile) {
    mobileControls.init(f2130, f2131, vF103);
    mobileControls.createOrRecreateJoystick();
    let v13839 = window.mobileControlPositions ? window.mobileControlPositions : config.mobileControlPositions;
    Object.keys(v13839).forEach(function (p17703) {
      let v13840 = v13839[p17703];
      let v13841 = document.getElementById(p17703);
      if (p17703 == "mobileShoot") {
        v13841.style.transform = v13840.scale ? "rotate(90deg) scale(" + v13840.scale + ")" : "rotate(90deg)";
      } else if (v13840.scale) {
        v13841.style.transform = "scale(" + v13840.scale + ")";
        controls.scaleMap[p17703] = v13840.scale;
      }
      ["left", "top", "right"].forEach(function (p17704) {
        if (v13840[p17704] || v13840[p17704] == 0) {
          v13841.style[p17704] = v13840[p17704] * 100 + "%";
        }
      });
      if (v13840.left == v13840.right) {
        v13841.style.margin = "auto";
      }
    });
  }
  this.locklessChange = function (p17705) {
    controls.enabled = p17705;
    if (io.connected || game.isSandbox) {
      if (controls.enabled) {
        enterGame();
      }
      UI.toggleControlUI(controls.enabled);
      if (!controls.enabled) {
        controls.resetKeys();
      }
    }
  };
  this.gamepad = new GamepadInput();
  var v13842 = RENDER.renderer.domElement;
  this.hasPointerlock = "pointerLockElement" in document || "mozPointerLockElement" in document || "webkitPointerLockElement" in document;
  if (this.hasPointerlock) {
    v13842.requestPointerLock = v13842.requestPointerLock || v13842.mozRequestPointerLock || v13842.webkitRequestPointerLock;
    function f2136(p17706) {
      if (!controls.tmpUnlock) {
        controls.enabled = document.pointerLockElement === v13842 || document.mozPointerLockElement === v13842 || document.webkitPointerLockElement === v13842;
        if (io.connected || game.isSandbox) {
          if (controls.enabled) {
            enterGame();
          }
          UI.toggleControlUI(controls.enabled);
          if (!controls.enabled) {
            controls.resetKeys();
          }
        }
      }
    }
    document.addEventListener("pointerlockchange", f2136, false);
    document.addEventListener("mozpointerlockchange", f2136, false);
    document.addEventListener("webkitpointerlockchange", f2136, false);
  }
  this.checkHardwareAccel = function () {
    var v13843 = true;
    try {
      var v13844 = v13842.getContext("webgl2");
      var v13845 = v13844.getExtension("WEBGL_debug_renderer_info");
      var v13846 = v13844.getParameter(v13845.UNMASKED_RENDERER_WEBGL);
      v13843 = !v13846.includes("SwiftShader");
    } catch (e175) {}
    return v13843;
  };
  const v13847 = v13842.onpointerrawupdate !== undefined && PointerEvent.prototype.getCoalescedEvents != null;
  this.toggleMouseInputs = function (p17707) {
    v13842.removeEventListener("drag", f2137, false);
    v13842.removeEventListener("mousemove", f2137, false);
    v13842.removeEventListener("pointerrawupdate", f2138, false);
    if (v13847 && p17707) {
      v13842.addEventListener("pointerrawupdate", f2138, false);
    } else {
      v13842.addEventListener("mousemove", f2137, false);
      v13842.addEventListener("drag", f2137, false);
    }
  };
  this.isn = 0;
  this.tmpInpts = [];
  this.getISN = function () {
    return this.isn++;
  };
  this.cntrlInput = {
    sensX: 20,
    sensY: 20,
    aimX: 15,
    aimY: 15,
    deadZoneR: 0.25,
    deadZoneL: 0.25,
    invert: false,
    vibration: true,
    vibrationMlt: 1,
    triggerThres: 0.1,
    gradSpeed: false
  };
  this.mblInput = {
    sensX: 1,
    sensY: 1,
    aimX: 1,
    aimY: 1,
    invert: false,
    vibration: true,
    vibrationMlt: 1,
    gradSpeed: false
  };
  this.gpSetts = 0;
  this.kbmInput = {
    aimX: [1],
    aimY: [1],
    sensX: [1],
    sensY: [1],
    invert: [false],
    scroll: [1]
  };
  this.mouseAccel = true;
  this.toggleADS = [0];
  this.adsToggled = false;
  this.mouseSkipFix = false;
  this.flickClamp = 500;
  this.masterLock = true;
  this.locked = false;
  this.enabled = false;
  this.idleTimer = 0;
  RENDER.camera.rotation.set(0, 0, 0);
  this.mouseX = 0;
  this.mouseY = 0;
  this.pchObjc = new game.THREE.Object3D();
  this.pchObjc.add(RENDER.camera);
  this.object = new game.THREE.Object3D();
  this.object.add(this.pchObjc);
  this.inputType = null;
  this.xDr = 0;
  this.yDr = 0;
  var v13848;
  var v13849;
  var v13850;
  var v13851;
  var v13852;
  var v13853;
  var v13854 = Math.PI / 2;
  var vLN02533 = 0;
  var vLN02534 = 0;
  this.getSetByWep = function (p17708, p17709) {
    if (p17708) {
      return controls[p17708][p17709];
    } else {
      return controls.kbmInput[p17709][(controls.gpSetts == 1 && game && game.tmpPlayer && game.tmpPlayer.currentWeaponId >= 0 ? game.tmpPlayer.currentWeaponId : -1) + 1];
    }
  };
  this.updateMouseInp = function () {
    if (controls.inputType != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    v13848 = controls.adsToggled ? controls.getSetByWep(controls.inputType, "aimX") : controls.getSetByWep(controls.inputType, "sensX");
    v13849 = config.mouseSens * v13848 * (controls.target ? config.camChaseSen : 1) * (RENDER.camera.fov / RENDER.fov);
    v13850 = controls.adsToggled ? controls.getSetByWep(controls.inputType, "aimY") : controls.getSetByWep(controls.inputType, "sensY");
    v13851 = config.mouseSens * v13850 * (controls.target ? config.camChaseSen : 1) * (RENDER.camera.fov / RENDER.fov);
    if ((!game || !game.detachedCam) && (window.spectating || controls.camRot)) {
      controls.pchObjc.rotation.x -= (vLN02534 || 0) * (v13851 || 0) * (controls.getSetByWep(controls.inputType, "invert") ? -1 : 1);
      if (!controls.unlockView) {
        controls.pchObjc.rotation.x = Math.max(-v13854, Math.min(v13854, controls.pchObjc.rotation.x));
      }
      controls.yDr = controls.pchObjc.rotation.x % Math.PI2;
      controls.object.rotation.y -= (vLN02533 || 0) * (v13849 || 0);
      controls.xDr = controls.object.rotation.y % Math.PI2;
    }
    vLN02533 = vLN02534 = 0;
  };
  function f2137(p17710, p17711) {
    if (!!controls.enabled && !window.locked && !window.noMouseInp) {
      if (p17710.stopPropagation) {
        p17710.stopPropagation();
      }
      if (p17710.preventDefault && p17710.cancelable) {
        p17710.preventDefault();
      }
      if (p17711 || p17710.isTrusted) {
        controls.inputType = p17711;
        controls.idleTimer = 0;
        f2127(p17710);
      }
    }
  }
  function f2138(p17712) {
    if (!!controls.enabled && !window.locked && !window.noMouseInp) {
      if (p17712.stopPropagation) {
        p17712.stopPropagation();
      }
      if (p17712.preventDefault && p17712.cancelable) {
        p17712.preventDefault();
      }
      controls.inputType = undefined;
      controls.idleTimer = 0;
      for (let v13855 of p17712.getCoalescedEvents()) {
        if (v13855.isTrusted) {
          f2127(v13855);
        }
      }
    }
  }
  v13842.ondragover = function (p17713) {
    if (p17713.cancelable) {
      p17713.preventDefault();
    }
  };
  this.toggleMouseInputs();
  v13842.dispatchEvent = () => {};
  function f2139(p17714, p17715) {
    if (p17715 != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    controls.inputType = p17715;
    if (!controls.masterLock) {
      if (controls.tmpUnlock) {
        controls.tmpUnlock = false;
        controls.toggle(true);
      } else if (!controls.enabled) {
        return controls.toggle(true);
      }
      if (document.activeElement == chatInput) {
        chatInput.blur();
      }
      if (window.tradeChatInput && document.activeElement == window.tradeChatInput) {
        window.tradeChatInput.blur();
      }
      if (p17714.stopPropagation) {
        p17714.stopPropagation();
      }
      if (p17714 && game && game.mainScript && game.mainScript.onMouseClick) {
        game.mainScript.onMouseClick(p17714.which, p17714.clientX || 0, p17714.clientY || 0);
      }
      if (p17714.which >= 0) {
        if (p17714.preventDefault && p17714.cancelable) {
          p17714.preventDefault();
        }
        f2134(null, 10000 + p17714.which, p17715);
        if (window.spectating) {
          if (p17714.which == 3) {
            window.spectMode(1);
          } else if (p17714.which == 1) {
            window.spectMode(-1);
          }
        }
      }
    }
  }
  v13842.addEventListener("mousedown", f2139, false);
  menuWindow.addEventListener("mousedown", function (p17716) {
    if (!controls.enabled) {
      if (p17716.which >= 0 && controls.inputChanger != null || p17716.which > 3 || p17716.which == 2) {
        if (p17716.preventDefault && p17716.cancelable) {
          p17716.preventDefault();
        }
        f2134(null, 10000 + p17716.which);
      }
    }
  }, false);
  function f2140(p17717, p17718) {
    if (p17718 != "cntrlInput" && controls.gamepad.active) {
      controls.gamepad.active = false;
    }
    controls.inputType = p17718;
    if (!controls.locked) {
      if (p17717.which >= 0) {
        if (p17717.preventDefault && p17717.cancelable) {
          p17717.preventDefault();
        }
        if (p17717 && game && game.mainScript && game.mainScript.onMouseUp) {
          game.mainScript.onMouseUp(p17717.which, p17717.clientX || 0, p17717.clientY || 0);
        }
        f2135(null, 10000 + p17717.which, p17718);
      }
    }
  }
  v13842.addEventListener("mouseup", f2140, false);
  menuWindow.addEventListener("mouseup", function (p17719) {
    if (!controls.enabled) {
      if (p17719.which >= 0 && controls.inputChanger != null || p17719.which > 3 || p17719.which == 2) {
        if (p17719.preventDefault && p17719.cancelable) {
          p17719.preventDefault();
        }
        f2135(null, 10000 + p17719.which);
      }
    }
  }, false);
  var vLN02535 = 0;
  if (v13842.addEventListener) {
    v13842.addEventListener("wheel", function (v13856) {
      var v13856 = window.event || v13856;
      var v13857 = -Math.max(-1, Math.min(1, v13856.wheelDelta || -v13856.detail));
      var v13858 = v13857 > 0 ? -1 : 1;
      if (window.spectating) {
        if (controls.spect.target) {
          controls.spect.followDis -= v13858 * 3;
          if (controls.spect.followDis < controls.spect.minD) {
            controls.spect.followDis = controls.spect.minD;
          }
          if (controls.spect.followDis > controls.spect.maxD) {
            controls.spect.followDis = controls.spect.maxD;
          }
        } else {
          controls.spect.speed += v13858;
          if (controls.spect.speed < 1) {
            controls.spect.speed = 1;
          }
          if (controls.spect.speed > 10) {
            controls.spect.speed = 10;
          }
        }
      }
      var v13859 = false;
      if (overlay.sprayWheelOpened()) {
        v13859 = true;
        overlay.sprayWheelChange(v13857);
      }
      if (overlay.propWheelOpened()) {
        v13859 = true;
        overlay.propWheelChange(v13857);
      }
      if (!v13859) {
        if (controls.skipScroll) {
          controls.skipScroll = false;
        } else {
          controls.scrollDelta = v13857;
        }
        var now = Date.now();
        if (now - vLN02535 > 50) {
          vLN02535 = now;
          f2134(null, 20000);
        }
      }
      if (v13856 && game && game.mainScript && game.mainScript.onMouseScroll) {
        game.mainScript.onMouseScroll(v13858);
      }
      return false;
    }, false);
  }
  windowHolder.addEventListener("wheel", function (p17721) {
    if (controls.inputChanger != null) {
      f2134(null, 20000);
      f2135(null, 20000);
    }
    return false;
  }, false);
  this.toggleGamepad = function (p17722) {
    this.gamepad.disabled = p17722;
    if (p17722) {
      this.gamepad._handleGamepadDisconnected();
    }
  };
  var vA782 = [];
  var vO455 = {
    mobileUI: {},
    mobileJump: {
      down: function () {
        mobileJump.style.transform = "scale(" + (controls.scaleMap.mobileJump || 1) * 1.1 + ")";
        f2134(null, controls.binds.jump.val);
      },
      up: function () {
        mobileJump.style.transform = "scale(" + (controls.scaleMap.mobileJump || 1) + ")";
        f2135(null, controls.binds.jump.val);
      }
    },
    mobileCrouch: {
      down: function () {
        mobileCrouch.style.transform = "scale(" + (controls.scaleMap.mobileCrouch || 1) + ")";
        f2134(null, controls.binds.crouch.val);
      },
      up: function () {
        mobileCrouch.style.transform = "scale(" + (controls.scaleMap.mobileCrouch || 1) + ")";
        f2135(null, controls.binds.crouch.val);
      }
    },
    mobileEsc: {
      down: function () {
        controls.toggle(false);
        requestAnimationFrame(function () {
          controls.resetKeys();
        });
      }
    },
    mobileAimShoot: {
      down: function () {
        mobileAimShoot.style.transform = "scale(" + (controls.scaleMap.mobileAimShoot || 1) * 1.1 + ")";
        let v13861 = game.players.list.filter(p17723 => p17723.isYou)[0].weapon;
        if (controls.isPressed("aim")) {
          this.alreadyAim = true;
          controls.keys[controls.binds.shoot.val] = 1;
        } else if (v13861.melee) {
          controls.keys[controls.binds.shoot.val] = 1;
        } else {
          f2133(controls.binds.aim.val, 1);
          if (v13861.scope) {
            this.shootOnUp = true;
          } else {
            this.readyToShoot = true;
            requestAnimationFrame(() => {
              if (this.readyToShoot) {
                controls.keys[controls.binds.shoot.val] = 1;
                if (v13861.nAuto) {
                  requestAnimationFrame(() => controls.keys[controls.binds.shoot.val] = 0, 100);
                  this.autoFire = setInterval(() => {
                    controls.keys[controls.binds.shoot.val] = 1;
                    requestAnimationFrame(() => controls.keys[controls.binds.shoot.val] = 0, 100);
                  }, v13861.rate);
                }
              }
            }, v13861.aimSpd + 50);
          }
        }
        if (window.spectating) {
          window.spectMode(-1);
        }
      },
      up: function () {
        this.readyToShoot = false;
        if (this.autoFire) {
          clearInterval(this.autoFire);
        }
        mobileAimShoot.style.transform = "scale(" + (controls.scaleMap.mobileAimShoot || 1) + ")";
        if (this.alreadyAim) {
          this.alreadyAim = false;
          controls.keys[controls.binds.shoot.val] = 0;
        } else {
          if (this.shootOnUp) {
            this.shootOnUp = false;
            controls.keys[controls.binds.shoot.val] = 1;
            requestAnimationFrame(() => controls.keys[controls.binds.shoot.val] = 0, 100);
          } else {
            controls.keys[controls.binds.shoot.val] = 0;
          }
          f2133(controls.binds.aim.val, 0);
        }
      }
    },
    mobileShoot: {
      down: function () {
        mobileShoot.style.transform = "rotate(90deg) scale(" + (controls.scaleMap.mobileShoot || 1) * 1.1 + ")";
        controls.keys[controls.binds.shoot.val] = 1;
        if (window.spectating) {
          window.spectMode(-1);
        }
      },
      up: function () {
        mobileShoot.style.transform = "rotate(90deg) scale(" + (controls.scaleMap.mobileShoot || 1) * 1.1 + ")";
        controls.keys[controls.binds.shoot.val] = 0;
      }
    },
    mobileScope: {
      down: function () {
        mobileScope.style.transform = "scale(" + (controls.scaleMap.mobileScope || 1) * 1.1 + ")";
        let v13862 = !controls.keys[controls.binds.aim.val];
        f2133(controls.binds.aim.val, v13862);
      },
      up: function () {
        mobileScope.style.transform = "scale(" + (controls.scaleMap.mobileScope || 1) + ")";
      }
    },
    mobileReload: {
      down: function () {
        mobileReload.style.transform = "scale(" + (controls.scaleMap.mobileReload || 1) * 1.1 + ")";
        f2134(null, controls.binds.reload.val);
      },
      up: function () {
        mobileReload.style.transform = "scale(" + (controls.scaleMap.mobileReload || 1) + ")";
        f2135(null, controls.binds.reload.val);
      }
    },
    mobileSwap: {
      down: function () {
        mobileSwap.style.transform = "scale(" + (controls.scaleMap.mobileSwap || 1) * 1.1 + ")";
        f2134(null, controls.binds.swap.val);
      },
      up: function () {
        mobileSwap.style.transform = "scale(" + (controls.scaleMap.mobileSwap || 1) + ")";
        f2135(null, controls.binds.swap.val);
      }
    },
    mobileKSwap: {
      down: function () {
        mobileKSwap.style.transform = "scale(" + (controls.scaleMap.mobileKSwap || 1) * 1.1 + ")";
        f2134(null, controls.binds.melee.val);
      },
      up: function () {
        mobileKSwap.style.transform = "scale(" + (controls.scaleMap.mobileKSwap || 1) + ")";
        f2135(null, controls.binds.melee.val);
      }
    }
  };
  for (var v13863 in vO455) {
    vO455[v13863].move = f2132;
  }
  if (this.isMobile) {
    mobileUI.addEventListener("touchstart", function (p17724) {
      if (!controls.masterLock) {
        if (!controls.enabled) {
          controls.toggle(true);
        }
        if (document.activeElement == chatInput) {
          chatInput.blur();
        }
        if (window.tradeChatInput && document.activeElement == window.tradeChatInput) {
          window.tradeChatInput.blur();
        }
        if (p17724.cancelable) {
          p17724.preventDefault();
        }
        for (var v13864 = p17724.changedTouches, vLN02536 = 0; vLN02536 < v13864.length; vLN02536++) {
          if (vO455[v13864[vLN02536].target.id]) {
            if (vO455[v13864[vLN02536].target.id].down) {
              vO455[v13864[vLN02536].target.id].down();
            }
            vA782.push(f2128(v13864[vLN02536], v13864[vLN02536].target.id));
          }
        }
      }
    }, false);
    mobileUI.addEventListener("touchmove", function (p17725) {
      if (!controls.masterLock) {
        if (p17725.cancelable) {
          p17725.preventDefault();
        }
        var v13865;
        for (var v13866 = p17725.changedTouches, vLN02537 = 0; vLN02537 < v13866.length; vLN02537++) {
          v13865 = f2129(v13866[vLN02537].identifier);
          if (v13865 >= 0) {
            if (vO455[vA782[v13865].cb].move) {
              vO455[vA782[v13865].cb].move(v13866[vLN02537], v13865);
            }
            vA782[v13865].screenX = v13866[vLN02537].screenX;
            vA782[v13865].screenY = v13866[vLN02537].screenY;
          }
        }
      }
    }, false);
    mobileUI.addEventListener("touchend", function (p17726) {
      if (!controls.locked) {
        var v13867;
        for (var v13868 = p17726.changedTouches, vLN02538 = 0; vLN02538 < v13868.length; vLN02538++) {
          v13867 = f2129(v13868[vLN02538].identifier);
          if (v13867 >= 0) {
            if (vO455[vA782[v13867].cb].up) {
              vO455[vA782[v13867].cb].up();
            }
            vA782.splice(v13867, 1);
          }
        }
      }
    }, false);
    mobileUI.addEventListener("touchcancel", function (p17727) {
      if (p17727.cancelable) {
        p17727.preventDefault();
      }
      var v13869;
      for (var v13870 = p17727.changedTouches, vLN02539 = 0; vLN02539 < v13870.length; vLN02539++) {
        v13869 = f2129(v13870[vLN02539].identifier);
        if (v13869 >= 0 && vO455[vA782[v13869].cb].up) {
          vO455[vA782[v13869].cb].up();
        }
        vA782.splice(v13869, 1);
      }
    }, false);
  }
  this.followCam = function (p17728, p17729) {
    v13871.set(p17728.x, p17728.y + p17728.height, p17728.z);
    controls.object.position.lerp(v13871, 0.9);
    RENDER.camera.position.set(0, 0, this.spect.followDis);
    RENDER.camera.updateProjectionMatrix();
    RENDER.updateFrustum();
  };
  this.setCamPosOff = function () {
    RENDER.camera.updateMatrixWorld();
    controls.object.position.setFromMatrixPosition(RENDER.camera.matrixWorld);
    RENDER.camera.position.set(0, 0, 0);
    RENDER.camera.rotation.set(0, 0, 0);
  };
  this.xVel = 0;
  this.yVel = 0;
  this.zVel = 0;
  var v13871 = new game.THREE.Vector3(0, 0, 0);
  var v13872 = new game.THREE.Quaternion();
  this.freeCam = function (p17730) {
    if (RENDER.camera && (v13871.set(0, 0, 0), this.isPressed("move", 0, "move_0") && (v13871.z -= 1), this.isPressed("move", 1, "move_1") && (v13871.z += 1), this.isPressed("move", 2, "move_2") && (v13871.x -= 1), this.isPressed("move", 3, "move_3") && (v13871.x += 1), this.keys[81] && (v13871.y -= 1), this.keys[69] && (v13871.y += 1), v13871.applyQuaternion(RENDER.camera.getWorldQuaternion(v13872)), !isNaN(v13871.x))) {
      var v13873 = (this.isPressed("crouch", null, "crouch") ? 0.08 : 0.04) * this.spect.speed * p17730;
      controls.object.position.add(v13871.multiplyScalar(v13873));
      RENDER.camera.position.set(0, 0, 0);
      RENDER.updateFrustum();
    }
  };
  this.camTarget = function (p17731, p17732, p17733, p17734, p17735) {
    this.target = {
      xD: p17734 || 0,
      yD: p17735 || 0,
      x: p17731 || 0,
      y: p17732 || 0,
      z: p17733 || 0
    };
  };
  this.camLookAt = function (p17736, p17737, p17738) {
    var v13874 = UTILS.getXDire(this.object.position.x, this.object.position.y, this.object.position.z, p17736, p17737, p17738);
    var v13875 = UTILS.getDir(this.object.position.z, this.object.position.x, p17738, p17736);
    this.target = {
      xD: v13874,
      yD: v13875,
      x: p17736 + config.camChaseDst * Math.sin(v13875) * Math.cos(v13874),
      y: p17737 - config.camChaseDst * Math.sin(v13874),
      z: p17738 + config.camChaseDst * Math.cos(v13875) * Math.cos(v13874)
    };
  };
  this.update = function (delta) {
    if (this.target) {
      var v13876 = UTILS.getAngleDst(this.object.rotation.y, this.target.yD);
      this.object.rotation.y += v13876 * delta * config.camChaseTrn;
      v13876 = UTILS.getAngleDst(controls.pchObjc.rotation.x, this.target.xD);
      this.pchObjc.rotation.x += v13876 * delta * config.camChaseTrn;
      v13876 = UTILS.getD3D(this.object.position.x, this.object.position.y, this.object.position.z, this.target.x, this.target.y, this.target.z) * delta * config.camChaseSpd;
      var v13877 = UTILS.getDir(this.object.position.z, this.object.position.x, this.target.z, this.target.x);
      var v13878 = UTILS.getXDire(this.object.position.x, this.object.position.y, this.object.position.z, this.target.x, this.target.y, this.target.z);
      this.object.position.x -= v13876 * Math.sin(v13877) * Math.cos(v13878);
      this.object.position.y += v13876 * Math.sin(v13878);
      this.object.position.z -= v13876 * Math.cos(v13877) * Math.cos(v13878);
      RENDER.updateFrustum();
    }
  };
  var v13879 = new game.THREE.Vector3();
  this.getWorldDirection = function () {
    return controls.object.getWorldDirection(v13879);
  };
  this.rotateCam = function (p17740, p17741, p17742) {
    RENDER.camera.rotation.y = p17740;
    RENDER.camera.rotation.x = p17741;
    RENDER.camera.rotation.z = p17742;
  };
  this.moveCam = function (p17743, p17744, p17745) {
    controls.object.position.set(p17743, p17744, p17745);
    RENDER.updateFrustum();
  };
  this.moveDirs = [[0, -1], [0, 1], [-1, 0], [1, 0]];
  this.updateMoveDir = function () {
    var vLN02540 = 0;
    var vLN02541 = 0;
    for (var vLN02542 = 0; vLN02542 < controls.binds.move.length; ++vLN02542) {
      if (controls.isPressed("move", vLN02542, "move_" + vLN02542)) {
        vLN02540 += controls.moveDirs[vLN02542][0];
        vLN02541 += controls.moveDirs[vLN02542][1];
      }
    }
    this.moveDir = vLN02540 == 0 && vLN02541 == 0 ? null : Math.atan2(vLN02541, vLN02540);
  };
  this.isPressed = function (p17746, p17747, p17748) {
    if (p17748 && controls.keys[p17748]) {
      return true;
    }
    if (!controls.binds[p17746]) {
      return false;
    }
    var v13880 = controls.binds[p17746];
    if (Array.isArray(v13880)) {
      v13880 = v13880[p17747];
    }
    return !!controls.keys[v13880.val] || !!controls.keys[v13880.altVal];
  };
  var v13881;
  window.addEventListener("keydown", f2134, false);
  window.addEventListener("keyup", f2135, false);
  if (!this.isMobile) {
    function f2141(p17749, p17750) {
      if (Math.abs(p17749) < p17750) {
        p17749 = 0;
      } else {
        p17749 -= Math.sign(p17749) * p17750;
        p17749 /= 1 - p17750;
      }
      return p17749;
    }
    function f2142(p17751, p17752, p17753) {
      p17751 = f2141(p17751, p17753);
      p17752 = f2141(p17752, p17753);
      let v13882 = Math.sqrt(p17751 * p17751 + p17752 * p17752);
      if (v13882 > 1) {
        p17751 /= v13882;
        p17752 /= v13882;
      }
      return [p17751, p17752];
    }
    function f2143(p17754, p17755) {
      var v13883 = Math.atan2(p17754, p17755);
      if (v13883 < 0) {
        v13883 += Math.PI * 2;
      }
      return v13883 * 180 / Math.PI;
    }
    function f2144(p17756, p17757) {
      var vLN453 = 45;
      var v13884 = vLN453 / 2;
      var vF2143 = f2143(p17756, p17757);
      var v13885 = vF2143 + v13884;
      return Math.floor(v13885 / vLN453);
    }
    var vF104 = p17758 => f2134(null, p17758, "cntrlInput");
    var vF105 = p17759 => f2135(null, p17759, "cntrlInput");
    this.mapping = {
      button_1: {
        KEY: "jump"
      },
      button_2: {
        KEY: "crouch"
      },
      button_3: {
        KEY: "reload"
      },
      shoulder_bottom_left: {
        KEY: "aim"
      },
      button_4: {
        KEY: "swap"
      },
      shoulder_top_left: {
        KEY: "swap"
      },
      shoulder_top_right: {
        KEY: "melee"
      },
      shoulder_bottom_right: {
        THRES: true,
        KEY: "shoot"
      },
      select: {
        KEY: "playerList"
      },
      d_pad_up: {
        KEY: "voiceChat"
      },
      d_pad_down: {
        KEY: "spray"
      },
      d_pad_left: {
        KEY: "interact"
      },
      d_pad_right: {
        KEY: "drop"
      }
    };
    var v13886 = Object.keys(this.gamepad._keyMapping.gamepad).concat(Object.keys(this.gamepad._keyMapping.axes));
    this.gamepad.on(["press", "hold", "release"], v13886, function (p17760) {
      var v13887 = controls.mapping[p17760.button];
      if (p17760.type == "press") {
        if (v13887 && controls.mapping[p17760.button].MOUSE && (p17760.value >= controls.cntrlInput.triggerThres || !controls.mapping[p17760.button].THRES)) {
          controls.fakeMouse(0, 0, 0, controls.mapping[p17760.button].MOUSE);
        } else if (v13887 && controls.mapping[p17760.button].KEY) {
          vF104(controls.mapping[p17760.button].KEY);
        }
      } else if (p17760.type == "release") {
        if (v13887 && controls.mapping[p17760.button].MOUSE) {
          controls.fakeMouse(1, 0, 0, controls.mapping[p17760.button].MOUSE);
        } else if (v13887) {
          vF105(controls.mapping[p17760.button].KEY);
        }
      } else if (p17760.type == "hold" && v13887 && controls.mapping[p17760.button].THRES) {
        if (p17760.value >= controls.cntrlInput.triggerThres) {
          controls.fakeMouse(0, 0, 0, controls.mapping[p17760.button].MOUSE);
        } else {
          controls.fakeMouse(1, 0, 0, controls.mapping[p17760.button].MOUSE);
        }
      }
      var v13888 = "onController" + (p17760.type == "hold" ? "Held" : p17760.type == "release" ? "Up" : "Press");
      if (game && game.mainScript && game.mainScript[v13888]) {
        game.mainScript[v13888](p17760.button + "", v13887 && controls.binds[v13887.KEY] ? controls.binds[v13887.KEY].val : 0);
      }
    });
    this.gamepad.on("hold", "stick_axis_left", function (p17761) {
      if (controls.cntrlInput.gradSpeed) {
        controls.speedLmt = Math.max(Math.abs(p17761.value[0]), Math.abs(p17761.value[1])) / (1 - controls.cntrlInput.deadZoneL);
      }
      var vF2141 = f2141(p17761.value[0], controls.cntrlInput.deadZoneL);
      var vF21412 = f2141(p17761.value[1], controls.cntrlInput.deadZoneL);
      var vF2144 = f2144(vF2141, vF21412);
      if (vF2141 || vF21412) {
        if (vF2144 == 0 || vF2144 == 8) {
          vF105(controls.binds.move[0].val);
          vF105(controls.binds.move[2].val);
          vF105(controls.binds.move[3].val);
          vF104(controls.binds.move[1].val);
        } else if (vF2144 == 1) {
          vF105(controls.binds.move[0].val);
          vF105(controls.binds.move[2].val);
          vF104(controls.binds.move[1].val);
          vF104(controls.binds.move[3].val);
        } else if (vF2144 == 2) {
          vF105(controls.binds.move[0].val);
          vF105(controls.binds.move[1].val);
          vF105(controls.binds.move[2].val);
          vF104(controls.binds.move[3].val);
        } else if (vF2144 == 3) {
          vF105(controls.binds.move[1].val);
          vF105(controls.binds.move[2].val);
          vF104(controls.binds.move[0].val);
          vF104(controls.binds.move[3].val);
        } else if (vF2144 == 4) {
          vF105(controls.binds.move[1].val);
          vF105(controls.binds.move[2].val);
          vF105(controls.binds.move[3].val);
          vF104(controls.binds.move[0].val);
        } else if (vF2144 == 5) {
          vF105(controls.binds.move[1].val);
          vF105(controls.binds.move[3].val);
          vF104(controls.binds.move[0].val);
          vF104(controls.binds.move[2].val);
        } else if (vF2144 == 6) {
          vF105(controls.binds.move[0].val);
          vF105(controls.binds.move[1].val);
          vF105(controls.binds.move[3].val);
          vF104(controls.binds.move[2].val);
        } else if (vF2144 == 7) {
          vF105(controls.binds.move[0].val);
          vF105(controls.binds.move[3].val);
          vF104(controls.binds.move[1].val);
          vF104(controls.binds.move[2].val);
        }
        return;
      } else {
        vF105(controls.binds.move[0].val);
        vF105(controls.binds.move[1].val);
        vF105(controls.binds.move[2].val);
        vF105(controls.binds.move[3].val);
        return;
      }
    });
    this.gamepad.on("release", "stick_axis_left", function (p17762) {
      vF105(controls.binds.move[0].val);
      vF105(controls.binds.move[1].val);
      vF105(controls.binds.move[2].val);
      vF105(controls.binds.move[3].val);
    });
    this.gamepad.on("hold", "stick_axis_right", function (p17763) {
      controls.fakeMouse(2, controls.applyDeadzone(p17763.value[0], controls.cntrlInput.deadZoneR), controls.applyDeadzone(p17763.value[1], controls.cntrlInput.deadZoneR), 0);
    });
    this.gamepad.on("press", "start", function (p17764) {
      controls.toggle(!controls.enabled);
    });
    this.applyDeadzone = function (p17765, p17766) {
      let v13889 = (Math.abs(p17765) - p17766) / (1 - p17766);
      if (v13889 < 0) {
        v13889 = 0;
      }
      return v13889 * (p17765 > 0 ? 1 : -1);
    };
  }
  this.fakeKey = function (p17767, p17768 = 0) {
    if (p17768 == 0) {
      f2134(null, p17767);
    }
    if (p17768 == 1) {
      f2135(null, p17767);
    }
  };
  var vO456 = {
    movementX: 0,
    movementY: 0,
    which: 0
  };
  this.fakeMouse = function (p17769 = 0, p17770 = 0, p17771 = 0, p17772 = 0, p17773) {
    p17773 = p17773 || "cntrlInput";
    vO456.movementX = p17770;
    vO456.movementY = p17771;
    vO456.which = p17772;
    if (p17769 == 0) {
      f2139(vO456, p17773);
    }
    if (p17769 == 1) {
      f2140(vO456, p17773);
    }
    if (p17769 == 2) {
      f2137(vO456, p17773);
    }
  };
  this.toggle = function (shouldEnable) {
    if (this.locked || this.masterLock) {
      if (UI.hasEndScreen && shouldEnable) {
        UI.toggleEndScreen();
      }
    } else if (windowHolder.style.display == "block") {
      if (shouldEnable) {
        UI.toggleWindow(false, this.gamepad.active);
      }
    } else if (controls.UsePointerLock) {
      if (shouldEnable) {
        requestPointerLock();
      } else {
        document.exitPointerLock();
      }
    } else {
      this.locklessChange(shouldEnable);
    }
  };
  this.resume = function () {
    if (!this.locked && !this.masterLock) {
      if (!controls.UsePointerLock) {
        this.locklessChange(true);
      } else {
        if (controls.tmpUnlock) {
          return false;
        }
        controls.enabled = true;
        if (!io.connected && !game.isSandbox) {
          return false;
        }
        enterGame();
        UI.toggleControlUI(true);
        controls.resetKeys();
      }
      return true;
    }
    return false;
  };
  this.disable = function () {
    controls.toggle(false);
    controls.locked = true;
  };
  this.reset = function (p17775) {
    this.adsToggled = false;
    this.keys = {};
    this.didPressed = {};
    this.speedLmt = 1;
    this.wSwap = 0;
    this.scrollDelta = 0;
    this.xDr = 0;
    this.yDr = 0;
    this.tmpInpts.length = 0;
    this.isn = 0;
    this.moveDir = null;
    this.skipScroll = false;
    this.inputChanger = null;
    this.target = null;
    this.locked = false;
    this.spect.target = null;
    if (p17775) {
      controls.pchObjc.rotation.x = 0;
      controls.object.rotation.y = 0;
      RENDER.camera.rotation.set(0, 0, 0);
      RENDER.zoom(1);
    }
  };
  this.resetKeys = function () {
    controls.adsToggled = false;
    controls.keys = {};
    controls.updateMoveDir();
  };
};